import { Center, Loader, Stack, Text } from '@mantine/core';

interface LoadingOverlayProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  height?: number | string;
}

export const LoadingOverlay = ({ 
  message = 'Loading...', 
  size = 'md',
  height = 200 
}: LoadingOverlayProps) => (
  <div>
    <Center style={{ height: typeof height === 'number' ? `${height}px` : height }}>
      <Stack align="center" gap="sm">
        <Loader size={size} variant="oval" color="blue" />
        <Text size="sm" c="dimmed">{message}</Text>
      </Stack>
    </Center>
  </div>
);
